import { ConnectionDetails } from '@/components/ConnectionDetails'
import { ConnectionMainContent } from '@/components/ConnectionMainContent'
import { ConnectionsLeftNav } from '@/components/ConnectionsLeftNav'
import { FC } from 'react'
import { Route, Routes } from 'react-router-dom'

const LeftNavRoutes: FC = () => {
	return (
		<Routes>
			<Route index element={<ConnectionsLeftNav />} />
			<Route path="add/:platform" element={<ConnectionDetails />} />
			<Route path=":connectionId" element={<ConnectionDetails />} />
		</Routes>
	)
}

const MainContentRoutes: FC = () => {
	return (
		<Routes>
			<Route index element={<ConnectionMainContent />} />
			<Route path="add" element={<ConnectionMainContent />} />
			<Route path=":connectionId" element={<ConnectionMainContent />} />
		</Routes>
	)
}

const ConnectionsRoutes: FC = () => {
	return (
		<div className="grid h-full grid-cols-[320px_1fr] w-full">
			<div className="border-r border-border">
				<LeftNavRoutes />
			</div>
			<div className="min-w-0">
				<MainContentRoutes />
			</div>
		</div>
	)
}

export default ConnectionsRoutes
